import { useUser } from '../contexts/UserContext';
import { isPro } from '../utils/subscription';

/**
 * 広告を非表示にすべきか判定する。
 * PROプラン以上のユーザーには広告を表示しない。
 */
export const useAdsHidden = (): boolean => {
  const { user } = useUser();
  return isPro(user?.subscription_plan ?? 0);
};
